module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/L22XtK/tc-custom/9781646568017.jpg?1718182736010",
      "alt": "This image is the cover for the book Sydney, One Way"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sydney, One Way\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What’s that sound? Rain? The wind? Anna’s heart sinks when she realises it’s the shower running and Matilda’s no longer in bed. Today Matilda is leaving."), _c('br'), _c('br'), _vm._v("Bound for Sydney, Australia, Matilda’s starting the adventure of a lifetime. She’s planned it for years, long before she met Anna. Although a new relationship, Anna loves Matilda and the thought of never seeing her again is breaking her heart."), _c('br'), _c('br'), _vm._v("What should Anna do? Ask Matilda to stay? Or be selfless and let her go? Her head says one thing, her heart another.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mags Hayward\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0